import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FiGithub, FiLinkedin, FiTwitter, FiInstagram, FiFacebook } from 'react-icons/fi';
import logo from '../../assets/images/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterTop>
            <FooterLogo>
              <Link to="/">
                <LogoImage src={logo} alt="Prince Yadav Logo" />
              </Link>
              <p>Building modern web experiences with passion and precision.</p>
            </FooterLogo>

            <FooterLinks>
              <FooterLinkColumn>
                <h3>Navigation</h3>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About</Link></li>
                  <li><Link to="/projects">Projects</Link></li>
                  <li><Link to="/services">Services</Link></li>
                  <li><Link to="/blog">Blog</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </FooterLinkColumn>

              <FooterLinkColumn>
                <h3>Services</h3>
                <ul>
                  <li><Link to="/services">Web Design</Link></li>
                  <li><Link to="/services">Frontend Development</Link></li>
                  <li><Link to="/services">Backend Development</Link></li>
                  <li><Link to="/services">Responsive Design</Link></li>
                  <li><Link to="/services">SEO Optimization</Link></li>
                </ul>
              </FooterLinkColumn>

              <FooterLinkColumn>
                <h3>Contact</h3>
                <ul>
                  <li>princeyadav3033@gmail.com</li>
                  <li>+91 (878) 704-3175</li>
                  <li>Delhi, India</li>
                </ul>
                <SocialLinks>
                  <SocialLink href="https://github.com/princeyadavpy" target="_blank" rel="noopener noreferrer">
                    <FiGithub />
                  </SocialLink>
                  <SocialLink href="https://www.linkedin.com/in/prince-yadav-898a902a7/" target="_blank" rel="noopener noreferrer">
                    <FiLinkedin />
                  </SocialLink>
                  <SocialLink href="https://www.facebook.com/share/18KAXfXhZJ/" target="_blank" rel="noopener noreferrer">
                    <FiFacebook />
                  </SocialLink>
                  <SocialLink href="https://instagram.com/prince_yaduwanshi_3033" target="_blank" rel="noopener noreferrer">
                    <FiInstagram />
                  </SocialLink>
                </SocialLinks>
              </FooterLinkColumn>
            </FooterLinks>
          </FooterTop>

          <FooterBottom>
            <Copyright>&copy; {currentYear} Prince Yadav. All rights reserved.</Copyright>
            <FooterBottomLinks>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </FooterBottomLinks>
          </FooterBottom>
        </FooterContent>
      </div>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  padding: 4rem 0 2rem;
  margin-top: 5rem;
  background-color: var(--glass-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border-top: 1px solid var(--glass-border);
  position: relative;
  z-index: 1;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

const FooterTop = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FooterLogo = styled.div`
  flex: 1;
  min-width: 250px;
  
  a {
    display: inline-block;
    margin-bottom: 1.5rem;
  }
`;

const LogoImage = styled.img`
  height: 100px;
  width: auto;
  transition: all 0.3s ease;
  
  .dark & {
    filter: invert(1);
    opacity: 0.9;
  }
  
  p {
    max-width: 300px;
    color: var(--text-secondary-light);
    
    .dark & {
      color: var(--text-secondary-dark);
    }
  }
`;

const FooterLinks = styled.div`
  flex: 2;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FooterLinkColumn = styled.div`
  flex: 1;
  min-width: 150px;
  
  h3 {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 30px;
      height: 2px;
      background: linear-gradient(135deg, var(--primary-light), var(--secondary-light));
      
      .dark & {
        background: linear-gradient(135deg, var(--primary-dark), var(--secondary-dark));
      }
    }
  }
  
  ul {
    list-style: none;
    padding: 0;
    
    li {
      margin-bottom: 0.8rem;
      
      a {
        color: var(--text-secondary-light);
        transition: color 0.3s ease;
        
        &:hover {
          color: var(--primary-light);
        }
        
        .dark & {
          color: var(--text-secondary-dark);
          
          &:hover {
            color: var(--primary-dark);
          }
        }
      }
      
      .dark & {
        color: var(--text-secondary-dark);
      }
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--bg-primary-light);
  color: var(--text-primary-light);
  transition: all 0.3s ease;
  
  &:hover {
    background-color: var(--primary-light);
    color: white;
    transform: translateY(-3px);
  }
  
  .dark & {
    background-color: var(--bg-primary-dark);
    color: var(--text-primary-dark);
    
    &:hover {
      background-color: var(--primary-dark);
      color: var(--bg-primary-dark);
    }
  }
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  
  .dark & {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const Copyright = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-secondary-light);
  
  .dark & {
    color: var(--text-secondary-dark);
  }
`;

const FooterBottomLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  
  a {
    font-size: 0.9rem;
    color: var(--text-secondary-light);
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--primary-light);
    }
    
    .dark & {
      color: var(--text-secondary-dark);
      
      &:hover {
        color: var(--primary-dark);
      }
    }
  }
`;

export default Footer;